import BaseBehavior from '../../../framework/base/base';
import pubsub from '../../../shared/utilities/pubsub';

export default class DisclaimerTrigger extends BaseBehavior {
	constructor(element) {
		super(element);

		element.addEventListener('click', e => {
			e.preventDefault();
			pubsub.publish('disclaimer/open');
		});
	}
}
